const state = {
    reportConfig: null,
    loadingReport: true,
    errorReport: null,
    isShowAlert: false,
    msgAlert: '',
    events: [],
    eventItems: [],
    reports: {
        races: {},
        events: {
            eventSelected: undefined,
            racesSelected: [],
            data: []
        }
    }
};

const mutations = {
    SET_REPORT_CONFIG(state, config) {
        state.reportConfig = config;
    },
    SET_LOADING(state, loading) { 
        state.loadingReport = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SHOW_ALERT(state, show) {
        state.isShowAlert = show;
    },
    SET_MSG_ALERT(state, msg) {
        state.msgAlert = msg;
    },
    SET_EVENTS(state, events) {
        state.events = events;
    },
    SET_EVENT_ITEMS(state, eventItems) {
        state.eventItems = eventItems;
    },
    SET_REPORTS(state, { type, index, value }) {
        state.reports[type][index] = value;
    }
};

const actions = {};

const getters = {
    getReportConfig: state => state.reportConfig,
    isReportEnabled: state => reportId => {
        return state.reportConfig?.reports?.find(report => report.id === reportId)?.enabled || false;
    },
    getReportSettings: state => reportId => {
        return state.reportConfig?.reports?.find(report => report.id === reportId)?.settings || {};
    },
    getEvents: state => state.events,
    isShowAlert: state => state.isShowAlert,
    msgAlert: state => state.msgAlert,
    getEventItems: state => state.eventItems,
    getReports: state => state.reports
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};